import { Spinner } from 'components/ui/Spinner/Spinner'
import { Flex } from 'components/uiKit'
import { isLanguage } from 'utils/helpers/i18n/getCurrentLanguage'
import { SupportedLanguages } from 'shared/types/types'

import Logo from 'assets/icons/logo/main-logo.svg?react'
import LogoGe from 'assets/icons/logo/main-logo-ge.svg?react'
import s from './MainLogo.module.scss'

export const MainLogo = () => {
  return (
    <Flex align="center" flex={1} justify="center" vertical>
      <div className={s.logo}>{isLanguage(SupportedLanguages.GE) ? <LogoGe /> : <Logo />}</div>
      <Spinner size={50} />
    </Flex>
  )
}
